<template>
  <div>
    <Header />

    <div class="personalServices">
      <Nav />
      <!-- <div class="container">

      </div> -->
      <LoginForm
        title="个人服务"
        :pics="[
          '/static/p1.png',
          '/static/p2.png',
          '/static/p3.png',
          '/static/p4.png'
        ]"
        :isPersonal="true"
        description="中华人民共和国公民凭身份证及个人身份实名认证登录服务平台，可进行本人基本信息完善填写、本人信息数据查询、授权数据档案查验、数据勘误申请等操作。"
      />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Nav from "@/components/Nav.vue";
import LoginForm from "../../components/LoginForm.vue";
export default {
  components: { Header, Nav, Footer, LoginForm }
};
</script>

<style lang="scss" scoped>
.personalServices {
  background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/personalServeice_bg.png")
    no-repeat;
  background-size: cover;
  padding-bottom: 70px;
  //   padding: 78px 0;
  //   background-position-y: 68px;
  .nav {
    background: #29447c;
  }
}
// .personalServices {
//   padding: 39px 0 41px 0;
//   margin: 0 auto;
//   .container {
//     .ps_layout {
//       background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/ps_layout.png") no-repeat;
//       background-size: cover;
//       width: 1195px;
//       height: 1030px;
//       display: flex;
//       .flex1 {
//         flex: 1;
//         padding: 133px;
//       }
//       .ps_info {
//         font-family: PingFang SC;
//         font-weight: 400;
//         color: #6e6e6e;
//         line-height: 30px;
//         .title {
//           font-size: 20px;
//           font-family: PingFang SC;
//           font-weight: bold;
//           color: #393939;
//           margin-bottom: 30px;
//         }
//         .content {
//           margin-bottom: 69px;
//         }
//         .form {
//           display: flex;
//           flex-direction: column;
//           font-size: 14px;
//           input {
//             height: 58px;
//             background-color: #f2f3f4;
//             border: 0;
//             border-radius: 29px;
//             padding-left: 39px;
//             margin-bottom: 21px;
//             width: 100%;
//             &:focus {
//               outline: none;
//             }
//           }
//           .btnGetCode {
//             position: absolute;
//             right: 0;
//             top: 20px;
//             color: #5673b0;
//             cursor: pointer;
//             border: 0;
//             font-size: 14px;
//           }
//           .disabled {
//             color: gray;
//             cursor: no-drop;
//           }
//           .btnLogin {
//             margin-top: 10px;
//             background-color: #3a61b1;
//             color: #fff;
//             height: 58px;
//             border: 0;
//             border-radius: 29px;
//             font-size: 20px;
//             margin-bottom: 47px;
//             cursor: pointer;
//           }
//         }
//         .statement {
//           font-size: 14px;
//         }
//       }
//     }
//   }
// }
</style>



// WEBPACK FOOTER //
// src/views/personalServices/index.vue